import { Role } from "../features/RoleManagement/interfaces/RoleConfig";
import User, { InvoicePaymentStatus } from "../interfaces/User";

export const DUE_SOON_EARLY_WINDOW_DAYS = 15;
export const DUE_SOON_LATE_WINDOW_DAYS = 5;

type BannerUser = Pick<
  User,
  "_isInternalUser" | "tenant_role_groups" | "storeCount"
>;

export const isEarlyWindowUser = (
  user: Partial<BannerUser> | null | undefined,
): boolean => {
  if (!user) return false;
  if (user._isInternalUser === true) return true;
  const isAdmin = (user.tenant_role_groups ?? []).some(({ name }) =>
    [Role.ADMIN, Role.SuperAdmin].includes(name as Role),
  );
  if (isAdmin) return true;
  return (user.storeCount ?? 1) > 1;
};

// Only gates the due-soon banner; overdue, grace and the full-page block are decided elsewhere.
export const shouldShowDueSoonBanner = (
  user: Partial<BannerUser> | null | undefined,
  invoicePaymentStatus:
    | Pick<InvoicePaymentStatus, "state" | "daysUntilDue">
    | null
    | undefined,
): boolean => {
  if (invoicePaymentStatus?.state !== "due_soon") return false;
  const days = invoicePaymentStatus.daysUntilDue;
  // Unknown day count: show rather than silently hide.
  if (days == null) return true;
  const window = isEarlyWindowUser(user)
    ? DUE_SOON_EARLY_WINDOW_DAYS
    : DUE_SOON_LATE_WINDOW_DAYS;
  return days <= window;
};
